<template>
  <v-container name="home" class="grey lighten-5">
      <v-layout row wrap>
        <v-flex xs12 lg4>
          <v-form
            ref="form"
          >
          <v-text-field
            v-model="token"
            label="Please enter token"
            required
          ></v-text-field>
          <v-btn
            :disabled="!token"
            color="success"
            @click="setToken"
          >
            Apply token
          </v-btn>
          </v-form>
        </v-flex>
        <v-flex xs12 lg2></v-flex>
        <v-flex xs12 lg6 v-if="token && token!=''">
          <h1>BI Dashboard</h1>
          <div v-for="(dashboard, name, index) in dashboards" v-bind:key="index">
            <h2>{{ name }}</h2>
            <span v-for="(item, itemName, itemIndex) in dashboard" v-bind:key="itemIndex"><router-link :to="{name:'dashboard', params: { platform: name, id: item, token: token }, query: { lang: $store.getters.currentLanguage || 'en' }}">{{item}}</router-link><br/></span>
          </div>
          <h2>Widgets</h2>
          <router-link :to="{name:'widget', params: { id: 'chart-funnel', key: 'SalesFunnel_funnelChart', token: token }, query: { lang: $store.getters.currentLanguage || 'en' }}">Widget</router-link>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import auth from '@/api/auth'
export default {
  name: 'home',
  data () {
    return {
      token: '',
      dashboards: {
        'inside': [
          'leads',
          'leads-basic',
          'ffu',
          'ffu-basic',
          'data-quality-contact',
          'dealer-roles',
          'sales-funnel',
          'sales-funnel-requalification',
          'sales-funnel-contract',
          'sales-funnel-contract-sale',
          'kkc',
          'kkc-performance',
          'sale',
          'stock',
          'gdpr',
          'gdpr-importer',
          'user-login',
          'salesman-activity'
        ],
        'gdpr': [
          'privacy-gdpr',
          'privacy-gdpr-importer'
        ],
        'leads': [
          'leads-overview',
          'leads-funnel',
          'lead-time-day-heatmap',
          'customer-insights',
          'leads-by-source',
          'conversions-by-source',
          'leads-funnel-sales-flow',
          'leads-overview-sales-flow',
          'kkc-leads',
          'leads-funnel-importer',
          'ffu-marketing-lead-invoice',
          'kkc-leads-invoice'
        ],
        'leads-management': [
          'leads-management-overview',
          'leads-management'
        ],
        'kkp': [
          'kkp-campaign-audience'
        ],
        'sp': [
          'walkaround-check-information',
          'potential-repairs',
          'sp-offers'
        ],
        'sale': [
          'vehicle-sale-pcd',
          'vehicle-sale',
          'market',
          'sales-report'
        ],
        'vp': [
          'vehicle-stock',
          'vehicle-stock-retail',
          'stock-report',
          'stock-history-report',
          'stock-co2-report',
          'marketplace'
        ],
        'rm': [
          'rm-appointments',
          'rm-booking',
          'rm-tire-manufacturer',
          'rm-tire-orders',
          'rm-not-in-stock'
        ],
        'sa': [
          'sa'
        ],
        'pp': [
          'dealer-login',
          'dealer-data-quality',
          'employee-data-quality'
        ],
        'cp': [
          'contact',
          'usage'
        ],
        'cpt': [
          'cpt-logins',
          'customer-portal-dealer'
        ],
        'demo': [
          'demo'
        ]
      }
    }
  },
  beforeCreate () {
    // TODO: refactor to be only on one component (App.vue)
    // set language from query param
    if (this.$route.query && this.$route.query.lang) {
      this.$log.info('Route query Language:', this.$route.query.lang)
      this.$store.commit('SET_LANGUAGE', this.$route.query.lang)
    } else {
      this.$store.commit('SET_LANGUAGE', 'en')
      this.$store.dispatch('fetchTranslations')
    }
  },
  methods: {
    setToken () {
      this.$store.commit('SET_AUTH_TOKEN', this.token)
      auth.setAuthToken(this.token)
    }
  },
  components: {
  }
}
</script>
